import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { Induction } from '@/types/models'

export const useManagerMenuStore = defineStore('managerMenu', () => {
  const induction = ref<Induction | undefined>(undefined)

  const opened = ref(false)

  const $reset = () => {
    induction.value = undefined
    opened.value = false
  }

  const close = () => {
    opened.value = false
    induction.value = undefined
  }

  const open = (newInduction: Induction) => {
    opened.value = true
    induction.value = newInduction
  }

  return {
    induction,
    opened,
    $reset,
    close,
    open,
  }
})
